/* Emiara reviews: load more, sorting, read more, photo viewer, review form. No dependencies. */
(function () {
  'use strict';

  function formatDate(iso, fmt) {
    var p = (iso || '').split('-');
    if (p.length !== 3) return iso || '';
    return fmt.replace('%Y', p[0]).replace('%y', p[0].slice(2)).replace('%m', p[1]).replace('%d', p[2])
      .replace('%-m', String(+p[1])).replace('%-d', String(+p[2]));
  }

  function sorters(kind) {
    var byDate = function (a, b) { return a.date < b.date ? 1 : a.date > b.date ? -1 : 0; };
    if (kind === 'recent') return byDate;
    if (kind === 'highest') return function (a, b) { return b.rating - a.rating || byDate(a, b); };
    if (kind === 'lowest') return function (a, b) { return a.rating - b.rating || byDate(a, b); };
    return null; // "photos": the stored order already has photos first, newest first
  }

  // Shows "Read more" only on clamped (overflowing) reviews. Runs on new cards, and on all cards again after the
  // stylesheet, fonts or the window size change, since the clamp depends on them. Measures all cards first and
  // changes the buttons afterwards, so the browser lays the page out once instead of once per card.
  function initReadMore(cards, root) {
    var todo = [];
    Array.prototype.forEach.call(cards, function (card) {
      var body = card.querySelector('[data-em-body]');
      var btn = card.querySelector('[data-em-readmore]');
      if (!body || !btn) return;
      if (!btn.dataset.ready) {
        btn.dataset.ready = '1';
        btn.addEventListener('click', function () {
          var open = body.classList.toggle('is-expanded');
          btn.textContent = open ? root.dataset.readLess : root.dataset.readMore;
        });
      }
      if (!body.classList.contains('is-expanded')) todo.push([btn, body]);
    });
    var fits = todo.map(function (t) { return t[1].scrollHeight <= t[1].clientHeight + 2; });
    todo.forEach(function (t, i) { t[0].hidden = fits[i]; });
  }

  function init(root) {
    var list = root.querySelector('[data-em-list]');
    var tpl = root.querySelector('[data-em-card-template]');
    var moreBtn = root.querySelector('[data-em-more]');
    var sortSel = root.querySelector('[data-em-sort]');
    var perPage = parseInt(root.dataset.perPage, 10) || 5;
    var total = parseInt(root.dataset.total, 10) || 0;
    var flags = {};
    root.querySelectorAll('template[data-em-flag]').forEach(function (t) { flags[t.dataset.emFlag] = t; });
    var all = null, view = null, shown = list.children.length, pending = null;

    function load() {
      if (all) return Promise.resolve(all);
      if (!pending) {
        pending = fetch(root.dataset.jsonUrl, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (d) {
            // big review sets arrive in parts: {"parts": [{"reviews": [...]}, ...]}
            all = d && d.parts ? d.parts.reduce(function (a, p) { return a.concat((p && p.reviews) || []); }, []) : (d && d.reviews) || [];
            view = all.slice();
            return all;
          })
          .catch(function (e) { pending = null; throw e; });
      }
      return pending;
    }

    function card(r) {
      var el = tpl.content.firstElementChild.cloneNode(true);
      el.querySelector('[data-em-stars-fill]').style.width = (r.rating * 20) + '%';
      el.querySelector('[data-em-stars]').setAttribute('aria-label', root.dataset.ratingLabel.replace('__R__', r.rating));
      var date = el.querySelector('[data-em-date]');
      date.setAttribute('datetime', r.date);
      date.textContent = formatDate(r.date, root.dataset.dateFormat);
      el.querySelector('[data-em-name]').textContent = r.author || '';
      if (r.country) {
        var c = el.querySelector('[data-em-country]');
        c.hidden = false;
        c.querySelector('[data-em-country-code]').textContent = r.country;
        if (flags[r.country]) c.querySelector('[data-em-flag-slot]').appendChild(flags[r.country].content.cloneNode(true));
      }
      if (r.title) {
        var t = el.querySelector('[data-em-title]');
        t.hidden = false;
        t.textContent = r.title;
      }
      var body = el.querySelector('[data-em-body]');
      (r.body || '').split('\n').forEach(function (line, i) {
        if (i) body.appendChild(document.createElement('br'));
        body.appendChild(document.createTextNode(line));
      });
      if (r.reply) {
        var reply = el.querySelector('[data-em-reply]');
        var replyText = reply.querySelector('[data-em-reply-text]');
        reply.hidden = false;
        r.reply.split('\n').forEach(function (line, i) {
          if (i) replyText.appendChild(document.createElement('br'));
          replyText.appendChild(document.createTextNode(line));
        });
      }
      if (r.photos && r.photos.length) {
        var box = el.querySelector('[data-em-photos]');
        box.hidden = false;
        r.photos.forEach(function (p) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'em-review__photo';
          b.dataset.emPhoto = p.u;
          var img = document.createElement('img');
          img.src = p.u + '&width=160&height=160&crop=center';
          img.width = 80; img.height = 80; img.loading = 'lazy'; img.decoding = 'async';
          img.alt = root.dataset.photoAlt.replace('__A__', r.author || '');
          b.appendChild(img);
          box.appendChild(b);
        });
      }
      return el;
    }

    function render(from, to) {
      var frag = document.createDocumentFragment();
      view.slice(from, to).forEach(function (r) { frag.appendChild(card(r)); });
      var holder = document.createElement('div');
      holder.appendChild(frag);
      var added = Array.prototype.slice.call(holder.children);
      added.forEach(function (n) { list.appendChild(n); });
      initReadMore(added, root);
      shown = to;
      if (moreBtn) moreBtn.hidden = shown >= view.length;
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        if (moreBtn.getAttribute('aria-busy') === 'true') return;
        moreBtn.setAttribute('aria-busy', 'true');
        load().then(function () {
          render(shown, Math.min(shown + perPage, view.length));
        }).catch(function () {}).then(function () { moreBtn.removeAttribute('aria-busy'); });
      });
    }

    if (sortSel) {
      sortSel.addEventListener('change', function () {
        load().then(function () {
          var keep = Math.max(shown, perPage); // read now: "Load more" may have added cards while loading
          var fn = sorters(sortSel.value);
          view = fn ? all.slice().sort(fn) : all.slice();
          list.textContent = '';
          render(0, Math.min(keep, view.length));
        }).catch(function () {});
      });
    }

    var recheck = function () { initReadMore(list.querySelectorAll('[data-em-review]'), root); };
    recheck();
    window.addEventListener('load', recheck);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(recheck);
    var css = document.querySelector('link[href*="emiara-reviews.css"]');
    if (css) css.addEventListener('load', recheck);
    var resizeTimer;
    window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(recheck, 150); });

    // Photo viewer
    var dlg = root.querySelector('[data-em-lightbox]');
    var dlgImg = root.querySelector('[data-em-lightbox-img]');
    var prev = root.querySelector('[data-em-lightbox-prev]');
    var next = root.querySelector('[data-em-lightbox-next]');
    var photos = [], idx = 0;
    function show(i) {
      idx = (i + photos.length) % photos.length;
      dlgImg.src = photos[idx].dataset.emPhoto + '&width=1400';
      dlgImg.alt = photos[idx].querySelector('img').alt;
      prev.hidden = next.hidden = photos.length < 2;
    }
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-em-photo]');
      if (!btn || !dlg) return;
      photos = Array.prototype.slice.call(btn.parentElement.querySelectorAll('[data-em-photo]'));
      show(photos.indexOf(btn));
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    });
    if (dlg) {
      root.querySelector('[data-em-lightbox-close]').addEventListener('click', function () { dlg.close(); });
      prev.addEventListener('click', function () { show(idx - 1); });
      next.addEventListener('click', function () { show(idx + 1); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
      dlg.addEventListener('close', function () { dlgImg.removeAttribute('src'); });
    }

    // Review form
    var wrap = root.querySelector('[data-em-form-wrap]');
    var mainToggle = root.querySelector('.em-reviews__actions [data-em-toggle-form]');
    function setForm(open) {
      if (!wrap) return;
      wrap.hidden = !open;
      if (mainToggle) {
        mainToggle.setAttribute('aria-expanded', String(open));
        mainToggle.textContent = open ? root.dataset.cancelLabel : root.dataset.writeLabel;
      }
      if (open) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    root.querySelectorAll('[data-em-toggle-form]').forEach(function (b) {
      b.addEventListener('click', function () { setForm(wrap.hidden); });
    });
    var form = wrap && wrap.querySelector('form');
    if (wrap && (wrap.querySelector('[data-em-form-success]') || wrap.querySelector('.em-form__error'))) setForm(true);
    if (form) {
      var media = form.querySelector('[data-em-media]');
      var previews = form.querySelector('[data-em-media-previews]');
      if (media && previews) {
        media.addEventListener('change', function () {
          previews.textContent = '';
          Array.prototype.forEach.call(media.files, function (f) {
            if (!/^image\//.test(f.type)) return;
            var img = document.createElement('img');
            img.alt = '';
            img.src = URL.createObjectURL(f);
            previews.appendChild(img);
          });
        });
      }
      form.addEventListener('submit', function (e) {
        var err = form.querySelector('[data-em-rating-error]');
        if (!form.querySelector('input[name="contact[Rating]"]:checked')) {
          e.preventDefault();
          if (err) err.hidden = false;
          form.querySelector('.em-form__rating').scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (err) err.hidden = true;
        if (media && media.files.length && media.dataset.endpoint && !form.dataset.uploaded) {
          e.preventDefault();
          var submit = form.querySelector('[data-em-submit]');
          submit.disabled = true;
          Promise.all(Array.prototype.map.call(media.files, function (f) {
            var fd = new FormData();
            fd.append('file', f);
            return fetch(media.dataset.endpoint, { method: 'POST', body: fd })
              .then(function (r) { return r.json(); })
              .then(function (d) { return d.url || ''; })
              .catch(function () { return ''; });
          })).then(function (urls) {
            form.querySelector('[data-em-photo-urls]').value = urls.filter(Boolean).join(' , ');
            form.dataset.uploaded = '1';
            submit.disabled = false;
            if (form.requestSubmit) form.requestSubmit(); else form.submit();
          });
        }
      });
    }
  }

  function boot() { document.querySelectorAll('[data-em-reviews]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
